import { StyleSheet } from "react-native";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import { Avatar } from "../Avatar";
import Box from "../Box";
import { LeaderboardPodiumBlock } from "./LeaderboardPodiumBlock";
import { LeaderboardXpAmount } from "./LeaderboardXpAmount";
import type { LeaderboardItem } from "./types";

type Place = 1 | 2 | 3;

export const PODIUM_CARD_HEIGHTS: Record<Place, number> = {
	1: 273,
	2: 220,
	3: 185,
};

const AVATAR_SIZES: Record<Place, number> = {
	1: 60,
	2: 46,
	3: 46,
};

type Props = LeaderboardItem & {
	isCurrentUser?: boolean;
};

export const LeaderboardPodiumCard = ({
	rank,
	username,
	xp,
	isCurrentUser = false,
}: Props) => {
	const theme = useAppTheme();

	const place = rank as Place;
	const isFirst = place === 1;
	const nameColor = isCurrentUser
		? theme.colors.primary
		: theme.colors.onSurface;

	return (
		<Box minHeight={PODIUM_CARD_HEIGHTS[place]} justifyContent="flex-end">
			<Box
				flex={1}
				gap={4}
				alignItems="center"
				justifyContent="center"
				paddingBottom={8}
			>
				<Box borderRadius={999} overflow="hidden">
					<Avatar size={AVATAR_SIZES[place]} username={username} />
				</Box>
				<Text
					numberOfLines={1}
					ellipsizeMode="tail"
					variant={isFirst ? "bodyMedium" : "bodySmall"}
					style={[
						styles.username,
						isFirst && styles.semibold,
						{ color: nameColor },
					]}
				>
					{username}
				</Text>
				<LeaderboardXpAmount
					value={xp}
					numberVariant={isFirst ? "bodyMedium" : "bodySmall"}
					numberStyle={[styles.semibold, { color: theme.colors.onSurface }]}
					unitVariant="labelSmall"
					unitStyle={{ color: theme.colors.onSurface }}
				/>
			</Box>
			<LeaderboardPodiumBlock place={place} />
		</Box>
	);
};

const styles = StyleSheet.create({
	semibold: {
		fontWeight: "600",
	},
	username: {
		width: "90%",
		textAlign: "center",
	},
});
